import * as z from 'helpers/zod'
import { PauseReasonsEnum } from './PauseListing.types'

export const pauseListingSchema = z.object({
  pauseReason: z.nativeEnum(PauseReasonsEnum, {
    error: 'Please select a pause reason'
  }),
  additionalInformation: z.string().optional()
})

export type PauseListingSchema = z.infer<typeof pauseListingSchema>
